import * as types from "./constants/index";

import { Helmet, HelmetProvider } from "react-helmet-async";
import {
  ThemeProvider as MuiThemeProvider,
  StylesProvider,
  jssPreset,
} from "@material-ui/core/styles";
import { QueryClient, QueryClientProvider } from "react-query";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import DateFnsUtils from "@date-io/date-fns";
import Locale from "./locale/locale";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import { ReactQueryDevtools } from "react-query/devtools";
import Routes from "./routes/Routes";
import { ThemeProvider } from "styled-components/macro";
import { create } from "jss";
import createTheme from "./theme";
import ls from "local-storage";
import axios from "./utils/axios";
import EParavoloContentProvider from "./context/eParavoloContext";

// const jss = create({
//   ...jssPreset(),
//   insertionPoint: document.getElementById("jss-insertion-point"),
// });

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

function App() {
  const theme = useSelector((state) => state.themeReducer);
  if (!ls.get("locale")) {
    ls("locale", "el-GR");
  }

  const dispatch = useDispatch();

  const checkLocalStorage = async () => {
    try {
      const username = ls("username");
      const auth_level = ls("auth_level");
      const accessToken = ls("accessToken");
      const id = ls("id");
      const port_auth_id = ls("port_auth_id");
      const port_auth = ls("port_auth");
      const afm = ls("afm");
      const gdpr_accept = ls("gdpr_accept");
      const amka_verified = ls("amka_verified");
      const birthyear = ls("birthyear");
      const fathername = ls("fathername");
      const firstname = ls("firstname");
      const lastname = ls("lastname");
      const mothername = ls("mothername");

      if ((username || afm) && auth_level) {
        if (accessToken) {
          axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
        }

        await dispatch({
          type: types.AUTH_SIGN_IN_SUCCESS,
          username,
          auth_level,
          accessToken,
          id,
          afm,
          gdpr_accept,
          amka_verified,
          birthyear,
          fathername,
          firstname,
          lastname,
          mothername,
          port_auth,
          port_auth_id,
        });
      }
    } catch (error) {
      console.error(error.message);
    }
  };

  useEffect(() => {
    checkLocalStorage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <React.Fragment>
      <HelmetProvider>
        <Helmet
          titleTemplate="%s"
          // defaultTitle="Material App - React Admin & Dashboard Template"
        />
        <StylesProvider
          // jss={jss}
          injectFirst
        >
          <EParavoloContentProvider>
            {/* <StylesProvider injectFirst> */}
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <MuiThemeProvider theme={createTheme(theme.currentTheme)}>
                <ThemeProvider theme={createTheme(theme.currentTheme)}>
                  <Locale>
                    <QueryClientProvider client={queryClient}>
                      <Routes />
                      <ReactQueryDevtools initialIsOpen={false} />
                    </QueryClientProvider>
                  </Locale>
                </ThemeProvider>
              </MuiThemeProvider>
            </MuiPickersUtilsProvider>
          </EParavoloContentProvider>
        </StylesProvider>
      </HelmetProvider>
    </React.Fragment>
  );
}

export default App;
